import ChevronLeftIcon from "@assets/svg/ChevronLeftIcon"
import { jobListByCompany } from "@endpoints/job.service"
import { SearchIcon } from "lucide-react"
import { useSnackbar } from "notistack"
import { useCallback, useEffect, useRef, useState } from "react"
import { useNavigate, useParams } from "react-router-dom"
import JobCard from "./components/JobCard"
import { NavLink } from "react-router-dom"
import LoadingAnimation from "@assets/svg/LoadingAnimation"
import { jobStatusFilters } from "../components/ViewByJob"

const LIMIT = 25

const JobListByHiringCompany = () => {
    const navigate = useNavigate()
    const { enqueueSnackbar } = useSnackbar()
    const { companyId: hiringCompanyId } = useParams();
    const scrollListRef = useRef(null)
    const sentinelRef = useRef(null)

    const [page, setPage] = useState(1)
    const [activeFilter, setActiveFilter] = useState<any>('All')
    const [isLoading, setIsLoading] = useState(true)
    const [isLoadingMore, setIsLoadingMore] = useState(false)
    const [hasMoreData, setHasMoreData] = useState(false)

    const [jobList, setJobList] = useState([])

    const fetchJobs = useCallback(
        async () => {
            try {
                if (page > 1) {
                    setIsLoadingMore(true)
                } else {
                    setIsLoading(true)
                }
                const { success, data } = await jobListByCompany({
                    hiringCompanyId,
                    page,
                    limit: LIMIT,
                    jobStatus: typeof activeFilter === 'string' ? undefined : activeFilter
                })
                if (success) {
                    setJobList(data)
                }
            } catch (error) {
                enqueueSnackbar(error, { variant: 'error' })
            } finally {
                setIsLoading(false)
                setIsLoadingMore(false)
            }
        },
        [page, activeFilter]
    )

    useEffect(() => {
        if (hiringCompanyId) {
            fetchJobs()
        }
    }, [hiringCompanyId,fetchJobs])

    return <div className="flex flex-col flex-1 min-h-0 bg-white rounded-md p-5">
        <div className="flex items-center gap-0.5">
            <button
                onClick={() => navigate("/job/by-hiring-company", { replace: true })}
                className="flex items-center self-start"
            >
                <ChevronLeftIcon className={"w-4 h-4"} fill="#4d4d4d" />
                <label className="text-xs font-medium text-charcoal cursor-pointer">
                    Back
                </label>
            </button>
            <div className="flex items-center text-light-black pl-4 text-xs">
                <NavLink
                    to={'/job/by-hiring-company'}
                    className="font-semibold text-light-grey">View by hiring company</NavLink>&nbsp;{'>'}&nbsp;
                <span className="font-semibold text-gray-500">Job Listing</span>
            </div>
        </div>
        {/* Top header */}
        <div className="flex items-center py-3.5 border-y mt-5 gap-28">
            {/* Search container */}
            <div className="flex items-center w-max border rounded-md bg-gray-50 px-3">
                <input
                    className="w-64 text-xs font-medium bg-transparent outline-none h-9"
                    placeholder="Search..."
                />
                <SearchIcon color="gray" size={16} />
            </div>
            {/* Filters container */}
            <div className="flex items-center gap-3">
                <span className="text-charcoal text-xs font-medium">Filters by :</span>
                <div className="flex items-center gap-5">
                    {
                        jobStatusFilters?.map((filter) => {
                            const isSelected = filter?.value === activeFilter
                            return <button
                                onClick={() => setActiveFilter(filter?.value)}
                                className="flex items-center gap-2">
                                <span className="font-medium text-xs text-charcoal">{filter?.label}</span>
                                <div className="flex h-5 w-5 rounded-full border-[1.5px] border-primary">
                                    {isSelected ?
                                        <div className="m-auto rounded-full h-3 w-3 bg-primary" />
                                        :
                                        null}
                                </div>
                            </button>
                        })
                    }
                </div>
            </div>
        </div>
        {/* Table Section */}
        <div className="flex flex-col flex-1 min-h-0">
            {/* <div className="font-bold border-b pb-2 text-light-black text-xs grid gap-8 grid-cols-[1.6fr_1fr_0.8fr_0.7fr_0.7fr] px-2">
                <span>Job Title</span>
                <span>Published Date</span>
                <span>Status</span>
                <span>Applied Candidates</span>
                <span className="text-center">Reference</span>
            </div> */}
            {
                isLoading ?
                    <div className="m-auto">
                        <LoadingAnimation color="black" />
                    </div>
                    :
                    !jobList?.length ?
                        <span className="m-auto text-sm font-medium text-light-black">No jobs available.</span>
                        :
                        // List Section
                        <div className="flex flex-col flex-1 min-h-0 overflow-y-scroll no-scrollbar">
                            {jobList?.map((job) => {
                                return <JobCard data={job} />
                            })}

                        </div>
            }

        </div>
    </div>
}

export default JobListByHiringCompany